module.exports = __webpack_public_path__ + "img/servipag.a518c3c5.png";